import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import { getMe, login as apiLogin } from '@/api/auth'
import type { LoginCredentials } from '@/types/auth'

export function useAuth() {
  const { user, tokens, isAuthenticated, isLoading, setAuth, clearAuth, setLoading } =
    useAuthStore()

  // On mount, verify stored token
  useEffect(() => {
    if (!tokens) {
      setLoading(false)
      return
    }
    getMe(tokens.access)
      .then((u) => setAuth(u, tokens))
      .catch(() => {
        clearAuth()
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function login(credentials: LoginCredentials) {
    const newTokens = await apiLogin(credentials)
    const user = await getMe(newTokens.access)
    setAuth(user, newTokens)
  }

  function logout() {
    clearAuth()
  }

  return { user, isAuthenticated, isLoading, login, logout }
}
